/* f-mobile.js — interactions for the mobile-parity layer.
   Loaded after f-theme.js. Footer accordion, explore tabs + card
   carousel, best-seller carousel, FAQ search. All progressive:
   every control degrades to a plain scrollable / linked layout. */
(function () {
  "use strict";
  var reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- footer accordion (mobile only; harmless on desktop) ---------- */
  window.srFootAcc = function (h2) {
    var col = h2.closest(".foot-col");
    if (!col) return;
    // only behave as accordion when the toggle is visible (mobile)
    var toggle = h2.querySelector(".foot-acc-toggle");
    if (toggle && getComputedStyle(toggle).display === "none") return;
    col.classList.toggle("is-open");
  };

  /* ---------- generic snap-carousel paging control ----------
     Wires a [data-xnav]/[.bs-nav] control to a scroll-snap track.
     Builds dots from the number of "pages" (track scrollWidth / clientWidth),
     updates active dot on scroll, and arrows page by one viewport. */
  function wireCarousel(track, nav) {
    if (!track || !nav) return;
    var prev = nav.querySelector("[data-xprev], .bs-prev");
    var next = nav.querySelector("[data-xnext], .bs-next");
    var dotsWrap = nav.querySelector("[data-xdots], .bs-dots");

    function pageCount() {
      // number of distinct snap positions, approx by viewport widths
      return Math.max(1, Math.round(track.scrollWidth / track.clientWidth));
    }
    function curPage() {
      if (track.clientWidth === 0) return 0;
      return Math.round(track.scrollLeft / track.clientWidth);
    }
    function buildDots() {
      if (!dotsWrap) return;
      var n = pageCount();
      dotsWrap.innerHTML = "";
      if (n <= 1) { nav.style.display = "none"; return; }
      nav.style.display = "";
      for (var i = 0; i < n; i++) {
        var b = document.createElement("button");
        b.type = "button";
        b.setAttribute("aria-label", "Go to group " + (i + 1));
        (function (idx) {
          b.addEventListener("click", function () {
            track.scrollTo({ left: idx * track.clientWidth, behavior: reduced ? "auto" : "smooth" });
          });
        })(i);
        dotsWrap.appendChild(b);
      }
      sync();
    }
    function sync() {
      var p = curPage(), n = pageCount();
      if (dotsWrap) {
        Array.prototype.forEach.call(dotsWrap.children, function (d, k) {
          d.classList.toggle("is-active", k === p);
        });
      }
      if (prev) prev.disabled = p <= 0;
      if (next) next.disabled = p >= n - 1;
    }
    if (prev) prev.addEventListener("click", function () {
      track.scrollBy({ left: -track.clientWidth, behavior: reduced ? "auto" : "smooth" });
    });
    if (next) next.addEventListener("click", function () {
      track.scrollBy({ left: track.clientWidth, behavior: reduced ? "auto" : "smooth" });
    });
    var raf;
    track.addEventListener("scroll", function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    }, { passive: true });
    var ro = new ResizeObserver(buildDots);
    ro.observe(track);
    buildDots();
  }

  /* ---------- explore: tabs + per-panel carousel ---------- */
  var xsection = document.querySelector(".explore .xtabs");
  if (xsection) {
    var tabs = document.querySelectorAll(".explore .xtab");
    var panels = document.querySelectorAll(".explore .xpanel");
    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var key = tab.getAttribute("data-xtab");
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle("is-active", on);
          t.setAttribute("aria-selected", on ? "true" : "false");
        });
        panels.forEach(function (p) {
          var on = p.getAttribute("data-xpanel") === key;
          p.hidden = !on;
        });
        // recompute dots for the now-visible panel
        var active = document.querySelector('.explore .xpanel[data-xpanel="' + key + '"]');
        if (active) window.dispatchEvent(new Event("resize"));
      });
    });
    document.querySelectorAll(".explore .xpanel").forEach(function (panel) {
      wireCarousel(panel.querySelector("[data-xtrack]"), panel.querySelector("[data-xnav]"));
    });
  }

  /* ---------- best-seller carousel ---------- */
  document.querySelectorAll("[data-bs]").forEach(function (bs) {
    wireCarousel(bs.querySelector(".bs-track"), bs.querySelector(".bs-nav"));
  });

  /* ---------- product grid: 2x2 page carousel (mobile only) ---------- */
  document.querySelectorAll("[data-gtrack]").forEach(function (track) {
    var nav = track.parentNode.querySelector("[data-gnav]");
    wireCarousel(track, nav);
  });

  /* ---------- FAQ help search ---------- */
  var fhelp = document.getElementById("fhelp");
  if (fhelp) {
    var search = fhelp.querySelector("[data-fhelp-search]");
    var nores = fhelp.querySelector(".fhelp-noresults");
    var norm = function (s) { return (s || "").toLowerCase(); };
    if (search) {
      search.addEventListener("input", function () {
        var q = norm(search.value.trim());
        fhelp.classList.toggle("is-searching", q.length > 0);
        var any = false;
        fhelp.querySelectorAll(".fhelp-cat").forEach(function (cat) {
          var catAny = false;
          cat.querySelectorAll(".qa").forEach(function (qa) {
            var txt = norm(qa.textContent);
            var hit = !q || txt.indexOf(q) !== -1;
            qa.hidden = !hit;
            if (hit) catAny = true;
          });
          cat.hidden = q && !catAny;
          if (catAny) any = true;
        });
        if (nores) nores.classList.toggle("show", q.length > 0 && !any);
      });
    }
  }
})();
